import { useCallback, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { buildPathFromUrl } from 'src/utils/buildPath';
import { useQueryParams } from './useQueryParams';

export const useRedirectToOverview = () => {
    const navigate = useNavigate();
    const { partnerId, chainId, storeType, type, countryId, cluster, pathname } = useQueryParams();

    const overviewUrl = useMemo(
        () => ({
            pathname: pathname,
            search: buildPathFromUrl(
                chainId ?? '',
                storeType ?? '',
                type ?? '',
                'overview',
                countryId ?? '',
                cluster ?? '',
                partnerId ?? ''
            ),
        }),
        [chainId, cluster, countryId, partnerId, storeType, type, pathname]
    );

    const redirectToOverview = useCallback(() => {
        navigate(overviewUrl);
    }, [navigate, overviewUrl]);

    return {
        redirectToOverview,
    };
};
